import React from 'react';
import type { ItemType } from 'antd/es/menu/interface';
import ROUTE_PATHS from '@/routes/route-paths';
import { Icon } from '@metaicg/sensei-ui';
import { ReactComponent as IconStore } from '@/shared/svg/icon-store.svg?react';
import { UserAuthorityRole } from '@/shared/models/auth/auth-data';

export type MenuItems = (ItemType & {
  key?: React.Key;
  icon?: React.ReactNode;
  label?: string;
  title?: string;
  disabled?: boolean;
  children?: MenuItems;
  accessRoles?: UserAuthorityRole[];
})[];

export const mainNavigation: MenuItems = [
  {
    key: ROUTE_PATHS.cabinets.main,
    icon: <IconStore />,
    label: 'common:components.nav.main.cabinets',
    accessRoles: [UserAuthorityRole.BO_ADMIN],
    children: [
      {
        key: ROUTE_PATHS.cabinets.assigned,
        label: 'common:components.nav.cabinets.assignedCabinets',
      },
      {
        key: ROUTE_PATHS.cabinets.unassigned,
        label: 'common:components.nav.cabinets.unassignedCabinets',
      },
    ],
  },
  {
    key: 'product-qa',
    icon: <Icon name="checkbox-multiple-line" />,
    label: 'common:components.nav.main.product',
    accessRoles: [UserAuthorityRole.BO_ADMIN, UserAuthorityRole.BO_DATASETS_REVIEWER],
    children: [
      {
        key: ROUTE_PATHS.productQa.main,
        label: 'common:components.nav.productQa.productQa',
      },
      {
        key: ROUTE_PATHS.datasets.main,
        label: 'common:components.nav.productQa.datasetQa',
      },
    ],
  },
  {
    key: ROUTE_PATHS.terminals.main,
    icon: <Icon name="smartphone-line" />,
    label: 'common:components.nav.main.terminals',
    accessRoles: [UserAuthorityRole.BO_ADMIN],
  },
  {
    key: ROUTE_PATHS.fallback.main,
    icon: <Icon name="user-settings-line" />,
    label: 'common:components.nav.main.fallback',
    accessRoles: [UserAuthorityRole.BO_ADMIN],
    children: [
      {
        key: ROUTE_PATHS.fallback.validationProfiles,
        label: 'common:components.nav.fallback.validationProfiles',
      },
      {
        key: ROUTE_PATHS.fallback.fallbackUsers,
        label: 'common:components.nav.fallback.fallbackUsers',
      },
      {
        key: ROUTE_PATHS.fallback.sessions,
        label: 'common:components.nav.fallback.sessions',
      },
    ],
  },
  {
    key: ROUTE_PATHS.storeProject.main,
    icon: <Icon name="shopping-bag-line" />,
    label: 'common:components.nav.main.storeProjects',
    accessRoles: [UserAuthorityRole.BO_ADMIN],
  },
  {
    key: ROUTE_PATHS.senseiUsers.main,
    icon: <Icon name="user-line" />,
    label: 'common:components.nav.main.user',
    accessRoles: [UserAuthorityRole.BO_ADMIN],
  },
  {
    key: ROUTE_PATHS.planogram.main,
    icon: <Icon name="layout-grid-line" />,
    label: 'common:components.nav.main.planogram',
    accessRoles: [UserAuthorityRole.BO_ADMIN],
    children: [
      {
        key: ROUTE_PATHS.planogram.tasks,
        label: 'common:components.nav.planogram.tasks',
      },
      {
        key: ROUTE_PATHS.planogram.validatedTasks,
        label: 'common:components.nav.planogram.validatedTasks',
      },
    ],
  },
];
